import React from "react";
import { getParam, push, setParam } from "pages/search/api/filterUrlMaker";
import { _t } from "app/i18n/i18n";
import { Button } from "react-bootstrap";

export const SidebarButton =
  (aggs) =>
  ({ value, label, field = "speciality" }) => {
    const isSelected = (getParam(field) || "") === (value || "");
    const onClick = () => push(setParam(field, value));
    const isDisabled = !aggs[field].includes(value) && value;

    return (
      <Button
        key={value}
        variant="link"
        className={className(isSelected, isDisabled)}
        onClick={onClick}
        disabled={isDisabled}
      >
        {_t(label)}
      </Button>
    );
  };

const className = (isSelected, isDisabled) =>
  "d-block sidebar p-0 pl-2 text-left lh-15 line-height-14 " +
  (isSelected ? "text-primary active" : isDisabled ? "text-gray" : "text-secondary");
